import React from 'react';
import calendarsReducer from '../../calendars/reducers';
import ConnectedCalendarsApp from '../../calendars/calendars';
import signupConfirmationReducers from '../../signup_confirmation/reducers/signupConfirmationReducers';
import SignupConfirmationResponsive from '../../signup_confirmation/signupConfirmation';

export const typeOfAppList = {
    calendars: {
        reducer: calendarsReducer,
        app: <ConnectedCalendarsApp />,
    },
    signupConfirmation: {
        reducer: signupConfirmationReducers,
        app: <SignupConfirmationResponsive />
    }
    // to-do: add more types later
};
